import React, {Component} from 'react';
import {
  // Button,
  Container,
  Divider,
  Form,
  // Header,
  // Image,
  Menu,
  // Segment,
  // TextArea,
} from 'semantic-ui-react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
// import memobind             from 'memobind';
import BodyClassName from 'react-body-classname';
import ImmutablePropTypes from 'react-immutable-proptypes';
// Editor
import {Editor} from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {EditorState, convertToRaw} from 'draft-js';

// Global
import getMessage from '../../global/getMessage';

// Molecule
// import BbcodeEditor         from '../../molecules/BbcodeEditor';

// Controller
import MainAdminController from './MainAdminWYSIWYGController';

// Style
import '../MainStyle/MainTwo.scss';
import './MainAdminWYSIWYG.scss';

const propTypes = {
  editTemplates       : PropTypes.func.isRequired,
  getTemplates        : PropTypes.func.isRequired,
  isLoadingTemplates  : PropTypes.bool,
  setTemplates        : PropTypes.func.isRequired,
  templates           : ImmutablePropTypes.map,
  tempTemplates       : ImmutablePropTypes.map,
  updateTempTemplates : PropTypes.func.isRequired,
};

const defaultProps = {
  isLoadingTemplates : false,
  templates          : Immutable.Map(),
  tempTemplates      : Immutable.Map(),
};

class MainAdminWYSIWYG extends Component {

  constructor() {
    super();
    this.state = {
      active      : 0,
      display     : 'bb',
      editorState : EditorState.createEmpty(),
      section     : null,
    };

    this.handleChangeMenu = this.handleChangeMenu.bind(this);
    this.handleChangeMenuSection = this.handleChangeMenuSection.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleAddContent = this.handleAddContent.bind(this);
    this.handleOnEditorStateChange = this.handleOnEditorStateChange.bind(this);
    this.handleOnContentStateChange = this.handleOnContentStateChange.bind(this);
  }

  componentDidMount() {
    this.props.getTemplates();
  }

  handleChangeMenu(e, menu) {
    if (menu.text === 'save') {
      this.handleSave();
    }
    else {
      this.setState({active: menu.index});
    }
  }

  handleChangeMenuSection(e, menu) {
    this.setState({section: menu.text});
  }

  handleEditContent(index, text, display) {
    const {
      editTemplates,
      templates,
      updateTempTemplates,
    } = this.props;
    const {
      active,
      section,
    } = this.state;

    const langSelected = active === 0 ? 'fr' : 'en';
    const newTemplates = templates.setIn([langSelected, 'section', section, 'content', index], text);
    if (display) {
      this.setState({display: display}, () => {
        updateTempTemplates(newTemplates);
        editTemplates(newTemplates);
      });
    }
    else {
      updateTempTemplates(newTemplates);
    }
  }

  handleDeleteContent(index) {
    const {
      editTemplates,
      templates,
      updateTempTemplates,
    } = this.props;
    const {
      active,
      section,
    } = this.state;

    const langSelected = active === 0 ? 'fr' : 'en';
    const newTemplates = templates.deleteIn([langSelected, 'section', section, 'content', index]);

    updateTempTemplates(newTemplates);
    editTemplates(newTemplates);
  }

  handleAddContent() {
    const {
      editTemplates,
      templates,
      tempTemplates,
      updateTempTemplates,
    } = this.props;

    const {
      active,
      section,
    } = this.state;

    const temp = tempTemplates.isEmpty() ? templates : tempTemplates;

    const langSelected = active === 0 ? 'fr' : 'en';
    const newContent = temp
      .getIn([langSelected, 'section', section, 'content'])
      .insert(0, '');

    const newTemplates = temp.setIn([langSelected, 'section', section, 'content'], newContent);

    updateTempTemplates(newTemplates);
    editTemplates(newTemplates);
  }

  handleMoveContent(index, e, menu) {
    const {
      editTemplates,
      tempTemplates,
      updateTempTemplates,
    } = this.props;

    const {
      active,
      section,
    } = this.state;

    const langSelected = active === 0 ? 'fr' : 'en';
    let newTemplates = tempTemplates;
    const direction = menu.text;

    if (direction === 'delete') {
      this.handleDeleteContent(index);
    }
    else {
      let toIndex = index;
      if (direction === 'up' && index > 0) {
        toIndex -= 1;
      }
      else if (direction === 'down' && index < newTemplates.getIn([langSelected, 'section', section, 'content']).size - 1) {
        toIndex += 1;
      }

      if (toIndex !== index) {
        const sourceItem = newTemplates.getIn([langSelected, 'section', section, 'content', index]);
        const targetItem = newTemplates.getIn([langSelected, 'section', section, 'content', toIndex]);

        newTemplates = newTemplates.setIn([langSelected, 'section', section, 'content', index], targetItem);
        newTemplates = newTemplates.setIn([langSelected, 'section', section, 'content', toIndex], sourceItem);
      }

      updateTempTemplates(newTemplates);
      editTemplates(newTemplates);
    }
  }

  handleSave() {
    const langSelected = this.state.active === 0 ? 'fr' : 'en';
    this.props.setTemplates(langSelected);
  }

  handleOnEditorStateChange(editorState) {
    this.setState({editorState});
  }

  handleOnContentStateChange() {
    console.log(convertToRaw(this.state.editorState.getCurrentContent()));
  }

  render() {
    const {
      isLoadingTemplates,
      templates,
      tempTemplates,
    } = this.props;

    isLoadingTemplates;
    templates;
    getMessage;

    const {
      active,
      // display,
      editorState,
      section,
    } = this.state;

    const items = [
      {
        key    : 'Francais',
        active : active === 0,
        name   : 'Francais',
      },
      {
        key    : 'Anglais',
        active : active === 1,
        name   : 'Anglais',
      },
      {
        key    : 'accueil',
        active : active === 2,
        name   : 'Retour Accueil',
      },
      {
        key      : 'save',
        active   : active === 2,
        disabled : tempTemplates.isEmpty(),
        name     : 'Save',
        text     : 'save',
      },
    ];

    const langSelected = active === 0 ? 'fr' : 'en';
    const templateSelected = templates.get(langSelected, Immutable.Map());
    // console.log('templateSelected', templateSelected);
    const itemsSection = [];
    templateSelected.get('menu', Immutable.Map()).forEach((tmp, key) => {
      if (key !== 'contact' && key !== 'facebook') {
        itemsSection.push({
          key    : key,
          active : key === section,
          name   : tmp,
          text   : key,
        });
      }
    });

    return (
      <BodyClassName className='sgr-main admin'>
        <Container className='sgr-admin'>
          <Divider hidden />

          <Menu
            items={items}
            onItemClick={this.handleChangeMenu}
          />

          <Menu
            items={itemsSection}
            onItemClick={this.handleChangeMenuSection}
            size='tiny'
          />

          <Form>
            <Editor
              editorClassName='editorClassName'
              editorState={editorState}
              initialEditorState={editorState}
              onContentStateChange={this.handleOnContentStateChange}
              onEditorStateChange={this.handleOnEditorStateChange}
              toolbarClassName='toolbarClassName'
              wrapperClassName='wrapperClassName'
            />
          </Form>
        </Container>
      </BodyClassName>
    );
  }

}

MainAdminWYSIWYG.propTypes = propTypes;
MainAdminWYSIWYG.defaultProps = defaultProps;

export const MainAdminTest = MainAdminWYSIWYG;

export default MainAdminController(withRouter(MainAdminWYSIWYG));



// WEBPACK FOOTER //
// ./src/organisms/MainAdminWYSIWYG/MainAdminWYSIWYG.js